import { baseViewModelToViewModelConverter } from "./converter";
import { useSiteControllerSettingBeds24FormModelMethods } from "./methods";

import type { SiteControllerSettingBaseFormModel } from "../../../base/type";
import type { SiteControllerSettingBaseFormModelOnSetViewModelType } from "../../../base/use-case/use-create-model/use-create-model";
import type { SiteControllerSettingBeds24FormModel } from "../../type";

type ViewModel = SiteControllerSettingBeds24FormModel["ViewModel"];
export type SiteControllerSettingBeds24FormModelOnSetViewModelType = <K extends keyof ViewModel>(
	values: { key: K; value: ViewModel[K] }[],
) => void;

type Props = {
	viewModel: SiteControllerSettingBaseFormModel["ViewModel"]; //
	onSetViewModel: SiteControllerSettingBaseFormModelOnSetViewModelType;
};

export const useCreateSiteControllerSettingBeds24FormModel = ({
	viewModel: baseViewModel,
	onSetViewModel, //
}: Props) => {
	const { viewModel: beds24ViewModel } = baseViewModelToViewModelConverter({ viewModel: baseViewModel });

	return {
		beds24ViewModel,
		...useSiteControllerSettingBeds24FormModelMethods({ viewModel: beds24ViewModel, onSetViewModel }),
	};
};
